// extracted by mini-css-extract-plugin
export var submitWrap = "CorporateForm-module--submitWrap--85532";
export var captcha = "CorporateForm-module--captcha--2f91e";
export var hide = "CorporateForm-module--hide--3f225";